import { render } from "./ImageList.vue?vue&type=template&id=60c07c70"
import script from "./ImageList.vue?vue&type=script&lang=js"
export * from "./ImageList.vue?vue&type=script&lang=js"
script.render = render

export default script